import Archive from './ArchivePage';

export default Archive;
